/* Keep the mobile shortcut tied to Xtra's native form, including variant changes. */
(() => {
  const main = document.getElementById('main-product');
  const sticky = document.querySelector('[data-bm-sticky]');
  if (!main || !sticky || main.dataset.bmPdpReady) return;
  main.dataset.bmPdpReady = 'true';
  const price = sticky.querySelector('[data-bm-sticky-price]');
  const button = sticky.querySelector('[data-bm-sticky-button]');
  let frame;
  const nativeButton = () => main.querySelector('.f8pr-button button[type="submit"]');
  function sync() {
    frame = null;
    const original = nativeButton();
    const originalPrice = main.querySelector('.f8pr-price');
    if (!original || !originalPrice) { sticky.hidden = true; return; }
    const copy = originalPrice.cloneNode(true);
    copy.querySelectorAll('.old-price,.small').forEach(el => el.remove());
    price.textContent = copy.textContent.trim();
    button.textContent = original.textContent.trim();
    button.disabled = original.disabled || original.classList.contains('disabled');
    sticky.hidden = innerWidth > 760 || original.getBoundingClientRect().bottom >= 0 || (document.body.classList.contains('bm-product-ch') && button.disabled);
  }
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  button.addEventListener('click', () => {
    const original = nativeButton();
    if (original && !button.disabled) original.click();
  });
  new MutationObserver(schedule).observe(main, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['disabled','class']});
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  sync();
})();
